import { Link } from '@portfolio/ui';

import { personalInfo } from '@/domains/portfolio/data/personal';

const URL_REGEX = /(https?:\/\/[^\s<]+)/g;
const TRAILING_PUNCT = /[.,;:!?)\]'"`]+$/;

interface LinkifiedTextProps {
  text: string;
}

export function LinkifiedText({ text }: LinkifiedTextProps) {
  return (
    <>
      {text.split(URL_REGEX).map((part, i) =>
        i % 2 === 0 ? part : <ChatLink key={i} raw={part} />
      )}
    </>
  );
}

function ChatLink({ raw }: { raw: string }) {
  const trail = raw.match(TRAILING_PUNCT)?.[0] ?? '';
  const url = trail ? raw.slice(0, -trail.length) : raw;
  const isCv = url.endsWith(personalInfo.cvPath);
  return (
    <>
      <Link
        href={url}
        className="underline decoration-primary/40 underline-offset-2 hover:decoration-primary"
        {...(isCv ? { external: false, download: personalInfo.cvFilename } : {})}
      >
        {url}
      </Link>
      {trail}
    </>
  );
}
